import {identityTransport} from "@/api/transport/identity.transport";

export function loginByEmailPassword(body) {
    return identityTransport.post('/v1/public/auth/login/email', body)
}
